var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('div',{staticClass:"vis-page-content"},[_c('VisContainer',{attrs:{"orgCode":_vm.orgCode,"tripId":parseInt(_vm.tripId),"openInNewVisible":false,"prefsKeyPrefix":"AdminPage"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }